const IpoSection = () => {
  return (
    <section className="about about--style1 bg-color">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            <div className="col-lg-6">
              <div className="about__thumb pe-lg-5" data-aos="fade-right" data-aos-duration="800">
                <div className="about__thumb-inner">
                  <div className="about__thumb-image floating-content">
                    <img className="dark" src="assets/images/new/ipo.jpg" alt="about-image" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                <div className="about__content-inner">
                  <h2 className="meet-oppurtanity">IPO -initial <span className="style2">public offerings </span></h2>

                  <p className="mb-0">
                    Access upcoming, open, and closed IPOs with complete transparency. Tap into institutional-grade allotment information and retail quotas, backed by efficient application workflows and real-time updates
                  </p>

                  <p className="mb-0">Our strong performance in IPOs has been a result of its vast experience in the Primary
                    Market, We have a dedicated research team who provides Clients with in-depth overviews of forthcoming IPOs as well as
                    investment recommendations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IpoSection;